import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Button,
  FormControl,
  TextField,
} from '@material-ui/core';
import clsx from 'clsx';

import FormValidator from 'components/formValidator';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: '8px',
    '&:not(:last-child)': {
      borderBottom: '1px solid #f1f1f1',
    },
  },
  details: {
    display: 'flex',
    '& > div': {
      padding: '0 10px 5px',
    },
    '& > div:first-child': {
      width: '45%',
    },
    '& > div:nth-child(2)': {
      width: '32%',
    },
    '& > div:last-child': {
      width: '23%'
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& > div': {
        width: 'auto !important',
      },
    },
    '& p': {
      margin: '0',
    },
  },
  actions: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    paddingTop: '5px',
    '& > button': {
      width: 'calc(50% - 3px)',
    },
  },
  form: {
    maxWidth: '480px',
  },
  formControl: {
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px',
  },
}));

const DESCRIPTOR = {
  note: { type: 'string', required: true, message: '' },
};

const Note = ({
  create,
  note,
  handleAdd,
  handleUpdate,
  handleDelete,
  toggleCreate,
}) => {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleCancelEdit = () => {
    if (create) {
      toggleCreate();
    } else {
      setEditMode(false);
    }
  };

  const handleSubmitNote = async (ev, { errors, formData }) => {
    ev.preventDefault();

    if (!errors) {
      if (create) {
        handleAdd(formData);
      } else {
        await handleUpdate({ ...note, ...formData });
        handleCancelEdit();
      }
    }
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const renderMode = () => {
    if (editMode || create) {
      return (
        <FormValidator
          initialData={{ note: note.note || '' }}
          descriptor={DESCRIPTOR}
          onSubmit={handleSubmitNote}
        >
          {({ formData, setFormValue, handleSubmit, errors = {} }) => {
            return (
              <form onSubmit={handleSubmit} className={classes.form}>
                <FormControl className={classes.formControl}>
                  <TextField
                    label="Note"
                    value={formData.note || ''}
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                    onChange={(ev) => {
                      setFormValue('note', ev.target.value);
                    }}
                    error={!!errors.note}
                  />
                </FormControl>
                <div className={classes.actions}>
                  <Button size="small" variant="contained" color="primary" type="submit"  className="note-save">
                    Save
                  </Button>
                  <Button size="small" color="primary" onClick={handleCancelEdit}  className="note-cancel">
                    Cancel
                  </Button>
                </div>
              </form>
            );
          }}
        </FormValidator>
      );
    }

    return (
      <div className={classes.details}>
        <div>
          <p>{note.note}</p>
        </div>
        <div>
          <p>
            Updated by <strong>{note.lastUpdatedBy}</strong><br />
          </p>
          <i>{note.lastChangedOn}</i>
        </div>
        <div>
          {confirmDelete ?
            (
              <>
                <Button size="small" variant="contained" color="secondary" onClick={() => handleDelete(note)} className="note-delete-confirm">
                  Confirm
                </Button>
                <Button size="small" color="primary" onClick={toggleConfirmDelete} className="note-delete-cancel">
                  Cancel
                </Button>
              </>
            ) : (
              <Button size="small" variant="contained" color="secondary" onClick={toggleConfirmDelete} className="note-delete">
                Delete
              </Button>
            )
          }
        </div>
      </div>
    );
  };

  return (
    <div className={clsx(classes.wrapper, 'profile-note')}>
      {renderMode()}
    </div>
  );
};

Note.propTypes = {
  create: PropTypes.bool,
  note: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func,
  handleAdd: PropTypes.func,
  handleDelete: PropTypes.func,
  toggleCreate: PropTypes.func,
};

Note.defaultProps = {
  create: false,
};

export default Note;
